export default __webpack_public_path__ + "static/media/window-glass.039efce5.jpg";